require('../modules/es6.date.now');
require('../modules/es6.date.to-json');
require('../modules/es6.date.to-iso-string');
require('../modules/es6.date.to-string');
require('../modules/es6.date.to-primitive');
module.exports = Date;



//////////////////
// WEBPACK FOOTER
// /Users/joost/repositories/mobile-water/apotheken/polseweg/polseweg-frontend/~/core-js/es6/date.js
// module id = ../../../../core-js/es6/date.js
// module chunks = 0